<template>
  <svg
    class="circular"
    :height="computedSize"
    :width="computedSize"
    :stroke="color"
    :style="{ '--rotation-duration': `${duration}s` }"
  >
    <circle
      class="circular__path"
      :cx="computedSize / 2"
      :cy="computedSize / 2"
      :r="computedSize / 2.5"
      fill="none"
      :stroke-width="computedStrokeWidth"
      stroke-miterlimit="10"
    />
  </svg>
</template>

<script setup>
import {defineProps, computed} from 'vue'

// TODO(i.zhuravlev): add caption. Different caption position on different size
// TODO(i.zhuravlev): currentColor mode "dimmed". Boolean prop
// TODO(i.zhuravlev): make tailwind.css classes generator instead svg attrs

const defaultDiameter = 20
const defaultStrokeWidth = 2

const sizeMap = {
  sm: 8,
  md: 20,
  lg: 40
}

const strokeWidthMap = {
  sm: 1,
  md: 2,
  lg: 4
}

const props = defineProps({
  size: {
    type: String,
    default: 'md',
    validator: (v) => ['sm', 'md', 'lg'].includes(v.toLowerCase()),
  },
  diameter: {
    type: Number,
    default: 20
  },
  strokeWidth: {
    type: Number,
    default: 2
  },
  color: {
    type: String,
    default: '#FDD500'
  },
  duration: {
    type: Number,
    default: 2
  }
})
const isDefaultDiameter = props.diameter === defaultDiameter || props.diameter === undefined
const computedSize = computed(() => isDefaultDiameter ? sizeMap[props.size] : props.diameter)

const isDefaultStrokeWidth = props.strokeWidth === defaultStrokeWidth || props.strokeWidth === undefined
const computedStrokeWidth = computed(() => isDefaultStrokeWidth ? strokeWidthMap[props.size] : props.strokeWidth)
</script>

<style lang="scss">
.circular {
  @apply flex;
  animation: rotate var(--rotation-duration, 2s) linear infinite;

  &__path {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
    animation: dash calc(var(--rotation-duration, 2s) * 0.75) ease-in-out infinite;
    stroke-linecap: round;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124;
    }
  }
}
</style>
